let _count = 0;
const _listeners = new Set();

function notify() {
  for (const l of _listeners) l();
}

export const loadingStore = {
  getSnapshot() {
    return _count;
  },
  subscribe(listener) {
    _listeners.add(listener);
    return () => _listeners.delete(listener);
  },
  begin() {
    _count += 1;
    notify();
  },
  end() {
    _count = Math.max(0, _count - 1);
    notify();
  },
  reset() {
    _count = 0;
    notify();
  },
};

